import axios from "axios";
import { config } from "config/config";

const API = axios.create({
    baseURL: `${config.backendPath}/api`,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

API.interceptors.request.use((request) => {
    const token = localStorage.getItem("authToken") || localStorage.getItem("token");
    if (token) {
        request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
});

API.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);

export default API;
